import tween       from '../webgl/helpers/Tween';
import CubicBezier from '../webgl/helpers/cubicBezier';
import App from '../stores/app.js'
import Emitter from '../core/emitter.js'

export default class HomeTitle extends HTMLElement {
    
    constructor() {
        super();

        this.introScale = 0;
        this.data = {
            letterDelay: 0.05,
            delay:       0,
            duration: 1.8,
        }
        this.el = this;
        this.intersectionObserver = new IntersectionObserver((entries)=>{
          entries.forEach((el)=>{
            if ( el.isIntersecting) {
                this.show()
            }
          });
        });

        this._scroll = 0;
        this._easedScroll = 0;
        this._onUpdate = this._onUpdate.bind(this);
        this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {

        if (this.hasAttribute('delay')) {
            this.data.delay = Number(this.getAttribute('delay'));
        }
        
        this.$title = this.querySelector('[data-title]');
        this.$content = this.querySelector('[data-content]');

        this.$title.style.opacity = 0;
        this.$content.style.opacity = 0;

        requestAnimationFrame(()=>{
            this.intersectionObserver.observe(this);
            if (App.lenis) {
                App.lenis.on('scroll', this._onScroll);
            }
            Emitter.on('update', this._onUpdate);

            if (window.wp) {
                this.$title.style.transform = `none`;
                this.$title.style.opacity   = 1;

                this.$content.style.transform = `none`;
                this.$content.style.opacity   = 1;
            }
         
        });

    }

    _onScroll(e) {
        this._scroll = e.animatedScroll;
    }

    disconnectedCallback() {
        App.lenis.off('scroll', this._onScroll);
        Emitter.off('update', this._onUpdate)
        this.intersectionObserver.unobserve(this);
    }

    _onUpdate() {
        this._easedScroll    += (this._scroll - this._easedScroll) * 0.1; 
        const progress       = Math.max(0, Math.min(1, this._easedScroll / (window.innerHeight )));
        const easedProgress  = CubicBezier( 0.775, 0.065, 0.345, 0.880, progress, 1 );;
        
        if (window.wp) {
            this.$title.style.transform = `none`;
            this.$title.style.opacity   = 1;

            this.$content.style.transform = `none`;
            this.$content.style.opacity   = 1;
        }
        else {
            this.$title.style.transform = `scale(${(0.9 + 0.1 * this.introScale) + easedProgress * 5 }) translateZ(0)`;
            this.$title.style.opacity   = Math.max(0, 1 - easedProgress * 3) * this.introScale;
            this.$content.style.opacity   = Math.max(0, 1 - easedProgress * 3) * this.introScale;
        }
    }

    show() {

        this.tween && this.tween.destroy()

        this.tween = tween({e:0}, {
            to: { e: 1 },
            delay: 0.7,//2.4,//this.data.delay,
            easing: [ 0.430, 0.195, 0.020, 1.000],
            duration:  2.2,
            step: (e) => {
                this.introScale = e;
            }
        })

    }

    hide() {
        this.tween && this.tween.destroy()
    }

}

if (!window.__is_server__) {
    customElements.define('block-welcome-screen', HomeTitle);
}